var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6663 70V63.3333C66.6663 59.7971 65.2616 56.4057 62.7611 53.9052C60.2606 51.4048 56.8692 50 53.333 50H26.6663C23.1301 50 19.7387 51.4048 17.2382 53.9052C14.7378 56.4057 13.333 59.7971 13.333 63.3333V70M53.333 23.3333C53.333 30.6971 47.3635 36.6667 39.9997 36.6667C32.6359 36.6667 26.6663 30.6971 26.6663 23.3333C26.6663 15.9695 32.6359 10 39.9997 10C47.3635 10 53.333 15.9695 53.333 23.3333Z",
    stroke: "#78C257",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6afa1a5539175271109f7d9fb3461027.svg";
export { ForwardRef as ReactComponent };